export default function selfCheckDefaults() {
  return {
    type               : 'selfcheck',
    selfcheckScore     : null,
    directScore        : null,
    selected           : false,
    selfCheckIsFinished: false,
    inputs             : {},
  }
}



// WEBPACK FOOTER //
// ./src/js/store/modules/selfcheck/self-check-defaults.js